export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge":604800,"secure":true},
 clients: {"default":{"httpEndpoint":"https://graphql.datocms.com/","tokenName":"apollo:default.token","authType":"Bearer","authHeader":"Authorization","tokenStorage":"cookie"}}
}